// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/StyleButtonFile.scss
// module id = 4264
// module chunks = 0